export enum ShippingPriceFormFields {
  PRICE = 'price',
  STATES = 'states',
}
